import { Entity, PrimaryGeneratedColumn, ManyToOne, JoinColumn } from 'typeorm';
import { CreativeUnitPackage } from "../creative-unit-package.entity";
import { Business } from "../../business/business.entity";
import { BusinessUser } from "../../business/business-user.entity";

@Entity('creativePackageBusinesses')
export class CreativePackageBusiness {
	constructor(value?: Partial<BusinessUser>) {
		for (const k in value) {
			this[k] = value[k];
		}
	}

	@PrimaryGeneratedColumn('uuid')
	id: string;

	@ManyToOne(() => CreativeUnitPackage, { onDelete: 'CASCADE' })
	@JoinColumn({ name: 'creativePackageId' })
	creativePackage: CreativeUnitPackage;

	@ManyToOne(() => Business, { onDelete: 'CASCADE' })
	@JoinColumn({ name: 'businessId' })
	business: Business;
}
